import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Subscription {
  active: boolean;
  plan?: string;
  expiry?: number;
  clips_remaining?: number;
}

interface User {
  id: string;
  email: string;
  role: 'admin' | 'editor' | 'viewer';
}

interface AuthState {
  user: User | null;
  token: string | null;
  subscription: Subscription | null;
  isAuthenticated: boolean;
  login: (user: User, token: string, subscription?: Subscription) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      subscription: null,
      isAuthenticated: false,
      login: (user, token, subscription) => set({ 
        user, 
        token, 
        subscription: subscription || null,
        isAuthenticated: true 
      }),
      logout: () => set({ user: null, token: null, subscription: null, isAuthenticated: false }),
    }),
    {
      name: 'clipgov-auth',
    }
  )
);

interface SubscriptionState {
  subscription: Subscription | null;
  setSubscription: (sub: Subscription) => void;
}

export const useSubscriptionStore = create<SubscriptionState>()(
  persist(
    (set) => ({
      subscription: null,
      setSubscription: (sub) => set({ subscription: sub }),
    }),
    {
      name: 'clipgov-subscription',
    }
  )
);
